import React from 'react';
import {Helmet} from 'react-helmet';

const MarketingHead = ({title, description}) => (
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description}/>
        <meta property="og:title" content={title}/>
        <meta property="og:description" content={description}/>
        <meta property="og:type" content="website"/>
        <meta name="theme-color" content="#141416"/>
    </Helmet>
);

export default MarketingHead;
